import employee_4 from '../../../assets/defaultImages/userDef.svg';
import 'yet-another-react-lightbox/styles.css';
import NotInformation from '../../../components/NotInformation';
import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import CustomCard from '../../../components/CustomCard';
import { CustomCheckbox } from '../../../components/CustomCheckbox';
import { permissionObj } from '../../../Helpers/permission';
import ResourcesCardsApp from "../Functionality/ResourcesCardsApp";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ResourcesCards = ({
    view,
    option,
    setBodyForExport,
    selectedList,
    setSelectedList,
    searchElement,
    setSearchElement,
    isAllChecked,
    setIsAllChecked,
    modified,
    setModified,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    setOpenViewer,
    setCurrImg
}) => {
    const {
        rowsPerPage,
        contractorId,
        supplierId,
        t,
        DEV,
        permission,
        handleDeleteAll,
        handleCheckboxChange,
        pagination,
        results,
        setResults,
        elementRef
    } = ResourcesCardsApp({
        view,
        option,
        selectedList,
        setSelectedList,
        setBodyForExport,
        searchElement,
        setIsAllChecked,
        modified,
        setModified
    });

    return (
        <>
            <div className={'col-12'}>
                <SearchSimple
                    id='txt_rc_search_simple'
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearchResults={setResults}
                    optionTable={option}
                    setBodyForExport={setBodyForExport}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={contractorId}
                    supplierId={supplierId}
                />
            </div>

            {results?.content?.length > 0 ? (
                <>
                    <div className='col-12'>
                        {(DEV || permission?.includes(permissionObj?.WEB_RESOURCES_DELETE)) && (
                            <CustomCheckbox
                                trans={t('de_/_select_all')}
                                checked={isAllChecked}
                                onChange={handleDeleteAll}
                            />
                        )}
                    </div>
                    <div className='panelTables d-flex flex-wrap-no-gap px-1' ref={elementRef}>
                        {results?.content?.map((item) => (
                            <div className='col-6 col-sm-4 col-md-3 col-lg-2 mb-3 px-1' key={item?.id}>
                                <CustomCard
                                    classes='h-100'
                                    classCard={`${
                                        selectedList?.includes(item?.id)
                                            ? 'background-error-code-50 border-full-error-code-400 selected-card'
                                            : ''
                                    }`}
                                >
                                    <div className='card-base-grid d-flex flex-column justify-content-between align-items-start p-2 h-100'>
                                        <div className='w-100'>
                                            {(DEV || permission?.includes(permissionObj?.WEB_RESOURCES_DELETE)) && (
                                                <CustomCheckbox
                                                    id={item?.id}
                                                    checked={selectedList?.includes(item?.id)}
                                                    onChange={handleCheckboxChange}
                                                    size='small'
                                                />
                                            )}
                                        </div>
                                        <div className='d-flex flex-column justify-content-center align-items-center text-center w-100'>
                                            <div className='img-resource'>
                                                <img
                                                    onClick={() => {
                                                        setOpenViewer(true);
                                                        setCurrImg(`data:image/png;base64,${item?.image}`);
                                                    }}
                                                    src={
                                                        item?.image != null
                                                            ? `data:image/png;base64,${item?.image}`
                                                            : employee_4
                                                    }
                                                    alt='employee_4'
                                                    className='custom-img-style-template'
                                                />
                                                <div className='emp_card_content w-100 d-flex justify-content-center align-items-center'>
                                                    <p className='text-uppercase m-0'>{item.name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CustomCard>
                            </div>
                        ))}
                    </div>
                    <div className='col-12'>{pagination()}</div>
                </>
            ) : (
                <div className='col-12'>
                    <NotInformation text={t('no_information')} card={true} />
                </div>
            )}
        </>
    );
};
export default ResourcesCards;
